import getMailboxExportStatus from '../services/getMailboxExportStatus';
import { orchestrator } from 'satcheljs';
import setIsExportMailboxRequestMade from '../mutators/setIsExportMailboxRequestMade';
import setExportLink from '../mutators/setExportLink';
import setExportStatus from '../mutators/setExportStatus';
import checkMailboxExportStatus from '../actions/checkMailboxExportStatus';

export default orchestrator(checkMailboxExportStatus, async () => {
    let response = await getMailboxExportStatus();

    if (response.ResponseClass === 'Error' && response.ResponseCode === 'ErrorItemNotFound') {
        setIsExportMailboxRequestMade(false);
    } else {
        setIsExportMailboxRequestMade(true);

        if (response.UserConfiguration && response.UserConfiguration.Dictionary) {
            response.UserConfiguration.Dictionary.forEach(dictionaryEntry => {
                switch (dictionaryEntry.DictionaryKey.Value[0]) {
                    case 'Status':
                        setExportStatus(dictionaryEntry.DictionaryValue.Value[0]);
                        break;
                    case 'Link':
                        setExportLink(dictionaryEntry.DictionaryValue.Value[0]);
                        break;
                    default:
                        break;
                }
            });
        }
    }
});
